import InformacionList from './InformacionList';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';

const InformaciónModule = {
    list: InformacionList,
    icon: StorefrontOutlinedIcon
}

export default InformaciónModule;